import emojiRegex from 'emoji-regex';

export function getEmojis(text) {
  const regex = emojiRegex();
  let match;
  const emojis = [];
  while ((match = regex.exec(text))) {
    const emoji = match[0];
    emojis.push(emoji);
  }

  return emojis;
}

export function removeEmojisFromString(emojis, text) {
  let newText = text;
  emojis.forEach(emoji => {
    newText = newText.replace(emoji, '');
  });
  return newText;
}



// WEBPACK FOOTER //
// ./src/utils/emoji.js